import { createClient as createSupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

let supabaseInstance: ReturnType<typeof createSupabaseClient> | null = null;

export function createClient() {
  // Enhanced logging for debugging
  if (typeof window !== 'undefined') {
    console.log('Supabase Configuration Check:', {
      hasUrl: !!supabaseUrl,
      hasKey: !!supabaseAnonKey,
      urlLength: supabaseUrl?.length || 0,
      keyLength: supabaseAnonKey?.length || 0,
    });
  }

  if (!supabaseUrl || !supabaseAnonKey) {
    console.error('Supabase configuration error:', {
      missingUrl: !supabaseUrl,
      missingKey: !supabaseAnonKey,
      envVars: typeof window !== 'undefined' ? {
        NEXT_PUBLIC_SUPABASE_URL: process.env.NEXT_PUBLIC_SUPABASE_URL ? 'exists' : 'missing',
        NEXT_PUBLIC_SUPABASE_ANON_KEY: process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ? 'exists' : 'missing',
      } : 'Server-side',
    });
    return null;
  }

  if (!supabaseInstance) {
    try {
      supabaseInstance = createSupabaseClient(supabaseUrl, supabaseAnonKey, {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
        },
      });
      console.log('Supabase client initialized successfully');
    } catch (error) {
      console.error('Failed to initialize Supabase client:', error);
      return null;
    }
  }

  return supabaseInstance;
}

export function supabase() {
  return createClient();
}